<h2 mat-dialog-title>Change Location Status</h2>

<mat-dialog-content>
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Analyzing location impact...</p>
  </div>

  <div *ngIf="!loading">
    <div class="location-summary">
      <h3>{{ location.name || 'Unnamed Location' }}</h3>
      <p class="subtitle" *ngIf="location.physicalType?.text">Type: {{ location.physicalType?.text }}</p>
    </div>

    <div class="impact-alert" *ngIf="childLocations.length > 0">
      <mat-icon>info</mat-icon>
      <div>
        <strong>Hierarchical Impact</strong>
        <p>This action will also explicitly update the status of <strong>{{ childLocations.length }}</strong> child location(s) associated with this location.</p>
      </div>
    </div>

    <div class="error-alert" *ngIf="occupiedLocations.length > 0">
      <mat-icon>error</mat-icon>
      <div>
        <strong>Occupied Locations Found</strong>
        <p>You cannot change the status to Inactive or Suspended because the following locations are currently occupied:</p>
        <ul>
          <li *ngFor="let loc of occupiedLocations | slice:0:5">{{ loc.name }}</li>
          <li *ngIf="occupiedLocations.length > 5">...and {{ occupiedLocations.length - 5 }} more.</li>
        </ul>
        <p class="resolution">Please discharge or transfer patients from these locations first.</p>
      </div>
    </div>

    <div class="error-alert mt-10" *ngIf="errorMessage">
        <mat-icon>error</mat-icon>
        <div>
          <p>{{ errorMessage }}</p>
        </div>
      </div>

    <form class="status-form">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Status</mat-label>
        <mat-select [formControl]="newStatusControl">
          <mat-option *ngFor="let option of statusOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Operational Status</mat-label>
        <mat-select [formControl]="newOperationalStatusControl">
          <mat-option *ngFor="let option of operationalStatusOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="submitting">Cancel</button>
  <button mat-flat-button color="primary" 
          [disabled]="!canSave || submitting || loading" 
          (click)="save()">
    <span *ngIf="!submitting">Confirm Change</span>
    <span *ngIf="submitting">Updating...</span>
  </button>
</mat-dialog-actions>
